import React from "react";
import { cn } from "../../lib/utils";
import { SITE_CONFIG } from "../../lib/constants";

export function Header({ className }) {
  return (
    <header
      className={cn(
        "relative py-6 md:py-8 px-4",
        "bg-ink",
        "border-b-2 border-gold/30",
        className
      )}
    >
      <div className="max-w-6xl mx-auto">
        {/* Desktop Layout */}
        <div className="hidden md:flex items-center justify-between gap-8">
          {/* Ankh Resources Logo */}
          <div className="flex-shrink-0 animate-on-load animate-slide-left stagger-1">
            <img
              src="/logos/ankhlogo.png"
              alt="Ankh Resources"
              className="h-16 w-auto object-contain"
            />
          </div>

          {/* Center - Masthead */}
          <div className="flex-1 text-center animate-on-load animate-fade-in stagger-2">
            <h1 className="masthead-title text-paper!">
              {SITE_CONFIG.name}
            </h1>
            <p className="mt-2 font-sans text-sm text-gold tracking-wide">
              {SITE_CONFIG.branding.primary} &bull; {SITE_CONFIG.branding.secondary}
            </p>
          </div>

          {/* Omniscan Logo with Starburst Badge */}
          <div className="flex-shrink-0 animate-on-load animate-slide-right stagger-1">
            <div className="relative flex items-center justify-center">
              {/* Starburst layers - tight wrap */}
              <div className="absolute w-16 h-16 bg-paper rotate-0" />
              <div className="absolute w-16 h-16 bg-paper rotate-[15deg]" />
              <div className="absolute w-16 h-16 bg-paper rotate-[30deg]" />
              <div className="absolute w-16 h-16 bg-paper rotate-45" />
              <div className="absolute w-16 h-16 bg-paper rotate-[60deg]" />
              <div className="absolute w-16 h-16 bg-paper rotate-[75deg]" />
              {/* Logo on top */}
              <img
                src="/logos/New Logonobg.png"
                alt="Omniscan AI"
                className="relative z-10 h-10 w-auto object-contain"
              />
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden space-y-4">
          {/* Logos Row */}
          <div className="flex items-center justify-between">
            <img
              src="/logos/ankhlogo.png"
              alt="Ankh Resources"
              className="h-12 w-auto object-contain"
            />
            {/* Omniscan Logo with Starburst Badge */}
            <div className="relative flex items-center justify-center">
              {/* Starburst layers - tight wrap for mobile */}
              <div className="absolute w-14 h-14 bg-paper rotate-0" />
              <div className="absolute w-14 h-14 bg-paper rotate-[15deg]" />
              <div className="absolute w-14 h-14 bg-paper rotate-[30deg]" />
              <div className="absolute w-14 h-14 bg-paper rotate-45" />
              <div className="absolute w-14 h-14 bg-paper rotate-[60deg]" />
              <div className="absolute w-14 h-14 bg-paper rotate-[75deg]" />
              {/* Logo on top */}
              <img
                src="/logos/New Logonobg.png"
                alt="Omniscan AI"
                className="relative z-10 h-8 w-auto object-contain"
              />
            </div>
          </div>

          {/* Masthead */}
          <div className="text-center">
            <h1 className="masthead-title text-paper! leading-tight">
              {SITE_CONFIG.name}
            </h1>
            <p className="mt-1 font-sans text-xs text-gold tracking-wide">
              {SITE_CONFIG.branding.primary}
              <br />
              {SITE_CONFIG.branding.secondary}
            </p>
          </div>
        </div>
      </div>

      {/* Decorative bottom border accent */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2">
        <div className="w-4 h-4 bg-gold rotate-45 border-2 border-ink shadow-lg" />
      </div>
    </header>
  );
}
